
const utils = {
    getAssocValue: function (obj, key) {
        return key.split(".").reduce(function(o, x) {
            return (typeof o == "undefined" || o === null) ? null : o[x];
        }, obj);
    },
    isObjectEmpty: function (obj) {
         return obj.constructor === Object && Object.keys(obj).length === 0;
    },
    isArrayEmpty: function (arr) {
         return Array.isArray(arr) && arr.length === 0;
    },
    isDataTypeFalse: function (o) {
        return !o || this.isArrayEmpty(o) || this.isObjectEmpty(o);
        
    },
    deepClone : function(object) {
        if (null == object || typeof object != "object") return object;
        // Handle Date
        if (object instanceof Date) {
            var copy = new Date();
            copy.setTime(object.getTime());
            return copy;
        }
        if (object instanceof Array) {
            return object.map(item => utils.deepClone(item))
        }

        var newObject = {};
        for (var key in object) {
            if (typeof object[key] === 'object') {
                newObject[key] = utils.deepClone(object[key]);
            } else {
                newObject[key] = object[key];
            }
        }
        return newObject;
    },
    roundToFixed: function(val, digits = 0) {
        
        const numToFloat = function(val) {
            const [mant, exp] = Number(val)
                .toExponential()
                .split('e')
                .map(str => +str);
            return {mant, exp};
        }
        
        if (typeof val === 'number' && typeof digits === 'number'
            && Number.isInteger(digits) &&
            (digits === 0 || Math.sign(digits) === 1)) {
            const valF = numToFloat(val);
            const valFNew = numToFloat(
              Math.round(+(valF.mant + 'e' + (valF.exp + digits)))
            );
            return +(valFNew.mant + 'e' + (valFNew.exp - digits));
        }
        return NaN;
    },
	roundToFixedDe:  function(val, digits, min) {
		if (!digits) {
			digits = 0;
		}
		
		let value = this.roundToFixed(val, digits);
		
		if (min) {
			value = Math.max(value, min);
		}
		return value.toFixed(digits).replace('.', ',');
	}
} 

const common = {
    meterToHectare: function (value) {
        if (!value || value == 0 ) {
            return null;
        }
    
        let ha = (value/10000.0).toFixed(5)
        let integer = ha.split('.')[0]
        let decimal = ha.split('.')[1]
        
        if (integer == 0) {
           for (let i = 0; i < decimal.length; i++) {
                if ('123456789'.indexOf(decimal[i]) > -1) {
                    decimal = decimal.substring(0, i+1);
                    break;
                }
           }

        } else {
            decimal = parseFloat('0.{}'.format(decimal)).toFixed(1).split('.')[0]
            if (decimal.charAt(decimal.length-1) == '0') {
               decimal = null;
            }
        }
        
        return '{}{}'.format(integer,decimal ? ','+decimal: '');
    }    
}    


export { 
    utils as default,
    common as common
};

